class DropdownSelector extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
    }

    connectedCallback() {
        this.querySelectorAll('.dropdown-option').forEach((opt, i) => {
            opt.dataset.originalIndex = i;
        });
        this.attachEventListeners();
    }

    attachEventListeners() {
        const optionsContainer = this.querySelector('.dropdown-options');
        if (!optionsContainer) return;

        optionsContainer.addEventListener('click', (e) => {
            e.stopPropagation();
            const option = e.target.closest('.dropdown-option');
            if (!option || option.classList.contains('disabled')) return;

            const isFirst = option === optionsContainer.firstElementChild;

            if (isFirst && !this.isOpen) {
                this.open();
            } else {
                this.selectOption(option);
            }
        });

        document.addEventListener('click', () => {
            this.close();
        });
    }

    selectOption(element) {
        const optionsContainer = this.querySelector('.dropdown-options');
        const currentFirst = optionsContainer.firstElementChild;

        this.querySelectorAll('.dropdown-option').forEach(opt => {
            opt.classList.remove('selected');
        });

        element.classList.add('selected');

        if (element !== currentFirst) {
            const arrow = currentFirst.querySelector('.dropdown-arrow');
            const checkmark = element.querySelector('.checkmark-icon');

            if (arrow && checkmark) {
                element.replaceChild(arrow, checkmark);
                currentFirst.appendChild(checkmark);
            }

            optionsContainer.prepend(element);
        }

        const remaining = [...optionsContainer.querySelectorAll('.dropdown-option:not(:first-child)')];
        remaining.sort((a, b) => Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));
        remaining.forEach(opt => optionsContainer.appendChild(opt));

        const value = element.dataset.value || element.textContent.trim();

        this.dispatchEvent(new CustomEvent('dropdown:select', {
            detail: { value, element },
            bubbles: true
        }));

        this.close();
    }

    close() {
        this.isOpen = false;
        const options = this.querySelector('.dropdown-options');
        const firstOption = this.querySelector('.dropdown-option:first-child');
        const arrow = firstOption?.querySelector('.dropdown-arrow');

        if (options) options.classList.remove('open');
        if (arrow) arrow.classList.remove('open');
    }

    open() {
        this.isOpen = true;
        const options = this.querySelector('.dropdown-options');
        const firstOption = this.querySelector('.dropdown-option:first-child');
        const arrow = firstOption?.querySelector('.dropdown-arrow');

        if (options) options.classList.add('open');
        if (arrow) arrow.classList.add('open');
    }
}

customElements.define('dropdown-selector', DropdownSelector);
